import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=c53e0cd8&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"
import style0 from "./OrderList.vue?vue&type=style&index=0&id=c53e0cd8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53e0cd8",
  null
  
)

export default component.exports